import React, { useState, useEffect, useRef } from 'react';
import api from '../utils/api';

const ContactPicker = ({ contactType, value, onChange, onPick, placeholder }) => {
  const [contacts, setContacts] = useState(null);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => {
    let ok = true;
    api.get('/contacts')
      .then(r => {
        if (!ok) return;
        const list = Array.isArray(r.data) ? r.data : (r.data.contacts || []);
        setContacts(list);
      })
      .catch(() => { if (ok) setContacts([]); });
    return () => { ok = false; };
  }, []);

  useEffect(() => {
    const onDown = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDown);
    return () => document.removeEventListener('mousedown', onDown);
  }, []);

  const q = (value || '').trim().toLowerCase();
  const matches = (contacts || []).filter(c =>
    c.contact_type === contactType &&
    (!q || (c.name || '').toLowerCase().includes(q) || (c.business_name || '').toLowerCase().includes(q))
  );
  const exact = matches.some(c => (c.name || '').toLowerCase() === q);

  const addNew = async () => {
    if (!q || saving) return;
    setSaving(true);
    try {
      const r = await api.post('/contacts', { contact_type: contactType, name: (value || '').trim() });
      const c = (r.data && (r.data.contact || r.data)) || {};
      onPick({ name: c.name || (value || '').trim(), phone: c.phone || '' });
    } catch (e) {
      onPick({ name: (value || '').trim(), phone: '' });
    }
    setSaving(false);
    setOpen(false);
  };

  return (
    <div ref={boxRef} style={{ position: 'relative' }}>
      <input
        className="form-input"
        type="text"
        value={value}
        placeholder={placeholder}
        autoComplete="off"
        onChange={(e) => { onChange(e); setOpen(true); }}
        onFocus={() => setOpen(true)}
      />
      {open && contacts && (
        <div style={{ position: 'absolute', left: 0, right: 0, top: '100%', marginTop: 4, background: '#fff', border: '1px solid var(--border-color)', borderRadius: 10, boxShadow: '0 8px 20px rgba(51,0,29,0.14)', zIndex: 40, maxHeight: 220, overflowY: 'auto' }}>
          {matches.slice(0, 6).map(c => {
            const ph = c.phone || c.phone_number || '';
            return (
              <div key={c.id}
                onMouseDown={(e) => { e.preventDefault(); onPick({ name: c.name, phone: ph }); setOpen(false); }}
                style={{ padding: '10px 12px', cursor: 'pointer', borderBottom: '1px solid rgba(38,25,31,0.06)' }}>
                <div style={{ fontSize: 14, fontWeight: 600 }}>{c.name}{c.business_name ? ' \u00b7 ' + c.business_name : ''}</div>
                <div style={{ fontSize: 12, color: ph ? 'var(--text-secondary)' : '#B4552E' }}>{ph || 'no phone saved \u2014 add one below'}</div>
              </div>
            );
          })}
          {q && !exact ? (
            <div onMouseDown={(e) => { e.preventDefault(); addNew(); }}
              style={{ padding: '10px 12px', cursor: 'pointer', color: '#4B002B', fontWeight: 700, fontSize: 13.5, background: '#F9F4EC' }}>
              {saving ? 'Saving\u2026' : '+ Add "' + (value || '').trim() + '" as new contact'}
            </div>
          ) : (
            <div style={{ padding: '9px 12px', fontSize: 12, color: 'var(--text-secondary)', background: '#F9F4EC' }}>
              {'+ New contact: type the name, then tap "Add" here'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ContactPicker;
